export const usePermissionConfig = () => {
  return {
    /**
     * 新增
     */
    XZ: 'OPS-XTPZ-XTCS-XZ',

    /**
     *  编辑
     */
    BJ: 'OPS-XTPZ-XTCS-BJ',
  } as const;
};
